import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { salinaConfig } from "./data";

export default function SalinaPage() {
  return <CityPageTemplate config={salinaConfig} />;
}